import Vue from 'vue'
import Router from 'vue-router'
import Notifications from 'vue-notification'
import Dashboard from '@/components/Dashboard'
import DashboardMonitoring from '@/components/DashboardMonitoring'
import DashboardOperation from '@/components/DashboardOperation'
import DashboardPerformance from '@/components/DashboardPerformance'
import ActiveAnnoucement from '@/components/ActiveAnnoucement'
import MemberActivitiesList from '@/components/MemberActivitiesList'
import MemberOperationList from '@/components/MemberOperationList'

//pages
import Login from '@/components/Page/Login'
import Page_Notifications from '@/components/Page/Notifications'
import Profile from '@/components/Page/Profile'
import CustomizeMenu from '@/components/Page/CustomizeMenu'
import UserManual from '@/components/Page/UserManual'
import VideoGuide from '@/components/Page/VideoGuide'

//Announcement
import SystemNotification from '@/components/SideMenu/Announcement/SystemNotification'
import MemberNotification from '@/components/SideMenu/Announcement/MemberNotification'
import SystemAnnouncement from '@/components/SideMenu/Announcement/SystemAnnouncement'
import MemberAnnouncement from '@/components/SideMenu/Announcement/MemberAnnouncement'


//Member
import MemberList from '@/components/SideMenu/Member/MemberList'
import MemberOnline from '@/components/SideMenu/Member/MemberOnline'
import BlackList from '@/components/SideMenu/Member/BlackList'
import MemberType from '@/components/SideMenu/Member/MemberType'
import MemberBalanceAdjustment from '@/components/SideMenu/Member/MemberBalanceAdjustment'
import MemberInfo from '@/components/SideMenu/Member/MemberInfo'
//Sub Page
import Sub_CheckingMember from '@/components/SideMenu/Member/Page/CheckingMember'
import Sub_SameTransactionIP from '@/components/SideMenu/Member/Page/SameTransactionIP'
import Sub_SamePromotionIP from '@/components/SideMenu/Member/Page/SamePromotionIP'
//Agent


import CSOnline from '@/components/SideMenu/Agent/CSOnline'

//ContentManagementSystem
import Banner from '@/components/SideMenu/ContentManagementSystem/Banner'
import FooterMenu from '@/components/SideMenu/ContentManagementSystem/FooterMenu'
import LiveChat from '@/components/SideMenu/ContentManagementSystem/LiveChat'
import QRcode from '@/components/SideMenu/ContentManagementSystem/QRcode'
import SocialMedia from '@/components/SideMenu/ContentManagementSystem/SocialMedia'
import FooterContent from '@/components/SideMenu/ContentManagementSystem/FooterContent'
import PromotionalVideo from '@/components/SideMenu/ContentManagementSystem/PromotionalVideo'
import ContactSettings from '@/components/SideMenu/ContentManagementSystem/ContactSettings'
import News from '@/components/SideMenu/ContentManagementSystem/News'

//Marketing
import SEOS from '@/components/SideMenu/Marketing/SEOS'
import WebmasterTools from '@/components/SideMenu/Marketing/WebmasterTools'
import HeaderFooterScripts from '@/components/SideMenu/Marketing/HeaderandFooterScripts'
import RegisterSource from '@/components/SideMenu/Marketing/RegisterSource'
import LoyaltyProgram from '@/components/SideMenu/Marketing/MemberRankingSetting'

//Bank
import BankBalance from '@/components/SideMenu/Banks/BankBalance'
import TransactionDetails from '@/components/SideMenu/Banks/TransactionDetails'
import BankList from '@/components/SideMenu/Banks/BankList'
import AccountList from '@/components/SideMenu/Banks/AccountList'
import CurrencyRates from '@/components/SideMenu/Banks/CurrencyRates'
import MemberDepositBank from '@/components/SideMenu/Banks/MemberDepositBank'
import MemberWithdrawalBank from '@/components/SideMenu/Banks/MemberWithdrawalBank'
import BankStatement from '@/components/SideMenu/Banks/BankStatement'
import ReportCurrencySetting from '@/components/SideMenu/Banks/ReportCurrencySetting'

//Deposit
import Deposit from '@/components/SideMenu/Deposit/Deposit'
import ManualDeposit from '@/components/SideMenu/Deposit/ManualDeposit'

//Withdraw
import Withdraw from '@/components/SideMenu/Withdraw/Withdraw'
import ManualWithdraw from '@/components/SideMenu/Withdraw/ManualWithdraw'
import SubAgentWithdraw from '@/components/SideMenu/Withdraw/SubAgentWithdraw'
import SubAgentManualWithdraw from '@/components/SideMenu/Withdraw/SubAgentManualWithdraw'



//Promotion
import Promotion from '@/components/SideMenu/Promotion/Promotion'
import ManualPromotion from '@/components/SideMenu/Promotion/ManualPromotion'
import ManualCashbackRebatePromotion from '@/components/SideMenu/Promotion/ManualCashbackRebatePromotion'
import PromotionSettings from '@/components/SideMenu/Promotion/PromotionSettings'
import PromotionDesign from '@/components/SideMenu/Promotion/PromotionDesign'
import ActivePromotion from '@/components/SideMenu/Promotion/ActivePromotion'
import Loyalty from '@/components/SideMenu/Promotion/Loyalty'
import DLSPromotion from '@/components/SideMenu/Promotion/DLSPromotion'
import DLSSetting from '@/components/SideMenu/Promotion/DLSSetting'
import Tournament from '@/components/SideMenu/Promotion/Tournament'
import Mission from '@/components/SideMenu/Promotion/Mission'
import PromotionRules from '@/components/SideMenu/Promotion/PromotionRules'
import PrizePoolSetup from '@/components/SideMenu/Promotion/PrizePoolSetup'
import RewardSetup from '@/components/SideMenu/Promotion/PrizeRewardSetup'

//GameSettings
import GameList from '@/components/SideMenu/GameSettings/GameList'
import GameSettings from '@/components/SideMenu/GameSettings/GameSettings'
import Top5GameProviders from '@/components/SideMenu/GameSettings/Top5GameProviders'
import Top5Game from '@/components/SideMenu/GameSettings/Top5Game'
import GameProvidersSetting from '@/components/SideMenu/GameSettings/GameProvidersSetting'
import Mega888Setting from '@/components/SideMenu/GameSettings/Mega888Setting'
import GameMassConfig from '@/components/SideMenu/GameSettings/GameMassConfig'
import GameListConfigByAgent from '@/components/SideMenu/GameSettings/GameListConfigByAgent'
import GameProviderBySubAgent from '@/components/SideMenu/GameSettings/GameProviderBySubAgent'
import MegaV3Setting from '@/components/SideMenu/GameSettings/MegaV3Setting'
import Pussy888Setting from '@/components/SideMenu/GameSettings/Pussy888Setting'
import Kiss918Setting from '@/components/SideMenu/GameSettings/Kiss918Setting'
import GameProviderListConfigByAgent from '@/components/SideMenu/GameSettings/GameProviderListConfigByAgent'
import AFB288Setting from '@/components/SideMenu/GameSettings/AFB288Setting'
import AFBCasinoSetting from '@/components/SideMenu/GameSettings/AFBCasinoSetting.vue'
import LG88Setting from '@/components/SideMenu/GameSettings/LG88Setting'
import GD88Setting from '@/components/SideMenu/GameSettings/GD88Setting'
import IGLotterySetting from '@/components/SideMenu/GameSettings/IGLotterySetting'
import NewKenoSetting from '@/components/SideMenu/GameSettings/NewKenoSetting'
//import DG3DSetting from '@/components/SideMenu/GameSettings/DG3DSetting'
import Wriket9Setting from '@/components/SideMenu/GameSettings/Wricket9Setting'
import GameLaunchUrl from '@/components/SideMenu/GameSettings/GameLaunchUrl'

//Reports
import TotalWinLoss from '@/components/SideMenu/Reports/TotalWinLoss'
import WinLoss from '@/components/SideMenu/Reports/WinLoss'
import WinLossV2 from '@/components/SideMenu/Reports/WinLossV2'
import DepositReport from '@/components/SideMenu/Reports/DepositReport'
import BetList from '@/components/SideMenu/Reports/BetList'
import WithdrawReport from '@/components/SideMenu/Reports/WithdrawReport'
import SubAgentWithdrawReport from '@/components/SideMenu/Reports/SubAgentWithdrawReport'
import TurnoverReport from '@/components/SideMenu/Reports/TurnoverReport'
import FinanceReport from '@/components/SideMenu/Reports/FinanceReport'
import PromotionReport from '@/components/SideMenu/Reports/PromotionReport'
import PositionTaking from '@/components/SideMenu/Reports/PositionTaking'
import DailyCSReport from '@/components/SideMenu/Reports/DailyCSReport'
import LoyaltyProgrammeReport from '@/components/SideMenu/Reports/LoyaltyProgrammeReport'
import TotalWinLossByProvider from '@/components/SideMenu/Reports/TotalWinLossByProvider'
import TotalWinLossByAG from '@/components/SideMenu/Reports/TotalWinLossByAG'
import TotalWinLossBySA from '@/components/SideMenu/Reports/TotalWinLossBySA'
import TotalWinLossByMA from '@/components/SideMenu/Reports/TotalWinLossByMA'
import TotalWinLossByMADetail from '@/components/SideMenu/Reports/TotalWinLossByMADetail'
import TotalWinLossByMember from '@/components/SideMenu/Reports/TotalWinLossByMember'
import TotalWinLossByMember2 from '@/components/SideMenu/Reports/TotalWinLossByMember2'
import AffiliateReport from '@/components/SideMenu/Reports/AffiliateReport'
import DLSReport from '@/components/SideMenu/Reports/DLSReport'
import RewardReport from '@/components/SideMenu/Reports/RewardReport'
import AFB1188Forecast from '@/components/SideMenu/Reports/AFB1188Forecast'
import RegisterSourceReport from '@/components/SideMenu/Reports/RegisterSourceReport'
import NewTotalWinLoss from '@/components/SideMenu/Reports/NewTotalWinLoss'
import TotalWinLossSubAgent from '@/components/SideMenu/Reports/TotalWinLossBySubAgent'
import TotalWinLossSubAgentDetail from '@/components/SideMenu/Reports/NewTotalWinLossSAG'
import CashPosition from '@/components/SideMenu/Reports/CashPosition'
import Sub_CashPosition from '@/components/SideMenu/Reports/Page/CPD'
import WLAdjustment from '@/components/SideMenu/Reports/WLAdjustment'
import BALADJRPT from '@/components/SideMenu/Reports/BalanceAdjustmentReport'
import USTR from '@/components/SideMenu/Reports/UnsettledTickets'
import PLMember from '@/components/SideMenu/Reports/PLMember'
import PLBranch from '@/components/SideMenu/Reports/PLBranch'
import TotalAgentSummary from '@/components/SideMenu/Reports/TotalAgentSummary'
import AFB1188BetReportByMatch from '@/components/SideMenu/Reports/AFB1188BetReportByMatch'
import TournamentReport from '@/components/SideMenu/Reports/TournamentReport'
import TournamentCurrentRanking from '@/components/SideMenu/Reports/TournamentCurrentRanking'
import TournamentSettlementReport from '@/components/SideMenu/Reports/TournamentSettlementReport'
import MissionReport from '@/components/SideMenu/Reports/MissionReport'
import ExpenseBreakdown from '@/components/SideMenu/Reports/ExpenseBreakdown'
import ProviderEventPayout from '@/components/SideMenu/Reports/ProviderEventPayout'
import PromotionBySubAgent from '@/components/SideMenu/Reports/PromotionBySubAgentReport'
import AccountingReport from '@/components/SideMenu/Reports/AccountingReport'
import OutstandingReport from '@/components/SideMenu/Reports/AccountOutstandingReport'
import MaintenanceReport from '@/components/SideMenu/Reports/AccountMaintenanceReport'
import OverviewReport from '@/components/SideMenu/Reports/AccountOverviewReport'
import OTPReport from '@/components/SideMenu/Reports/OTPReport'


//AGENT SETTING
import CreateDomain from '@/components/SideMenu/AgentSetting/CreateDomain'
import CreateDomain2 from '@/components/SideMenu/AgentSetting/CreateDomain2'
import AgentCustomize from '@/components/SideMenu/AgentSetting/AgentCustomize'
import DepositCustomize from '@/components/SideMenu/AgentSetting/DepositCustomize'
import RegisterCustomize from '@/components/SideMenu/AgentSetting/RegisterCustomize'
import CreateBrand from '@/components/SideMenu/AgentSetting/CreateBrand'
import CreateBrand2 from '@/components/SideMenu/AgentSetting/CreateBrand2'
import BalanceHistory from '@/components/SideMenu/AgentSetting/BalanceHistory'
// import PositionTakingSetting from '@/components/SideMenu/AgentSetting/PositionTakingSetting'
import PositionTakingSettingNew from '@/components/SideMenu/AgentSetting/PositionTakingSettingNew'
import AgentHierarchy from '@/components/SideMenu/AgentSetting/AgentHierarchy'
import SubAgentHierarchy from '@/components/SideMenu/AgentSetting/SubAgentHierarchy'
import FingerPrint from '@/components/SideMenu/AgentSetting/FingerPrint'
import CreateSubAgent from '@/components/SideMenu/AgentSetting/CreateSubAgent'
import CreateSubAgentCandidate from '@/components/SideMenu/AgentSetting/CreateSubAgentCandidate'
//import SubAgentPayoutScheme from '@/components/SideMenu/AgentSetting/SubAgentPayoutScheme'
import SubAgentCreditHistory from '@/components/SideMenu/AgentSetting/SubAgentCreditHistory'
import TemplateSkinDetails from '@/components/SideMenu/AgentSetting/TemplateSkinDetails'
import AgentSelfService from '@/components/SideMenu/AgentSetting/AgentSelfService'
import AgentDashboard from '@/components/SideMenu/AgentSetting/AgentDashboard'
import ResendFailedFreeRounds from '@/components/SideMenu/AgentSetting/ResendFailedFreeRounds'
import GameAttributeSetting from '@/components/SideMenu/AgentSetting/GameAttributeSetting'

//SystemSetting
import AgentList from '@/components/SideMenu/SystemSetting/AgentList'
import CreateRole from '@/components/SideMenu/SystemSetting/CreateRole'

// Logs
import AgentLogs from '@/components/SideMenu/Logs/AgentLogs'
import MemberLogs from '@/components/SideMenu/Logs/MemberLogs'
import DepositLogs from '@/components/SideMenu/Logs/DepositLogs'
import WithdrawLogs from '@/components/SideMenu/Logs/WithdrawLogs'
import PromotionLogs from '@/components/SideMenu/Logs/PromotionLogs'
import VisitorLogs from '@/components/SideMenu/Logs/VisitorLogs'
import BalAdjLogs from '@/components/SideMenu/Logs/BalAdjLogs'
import MemberMaxWinLogs from '@/components/SideMenu/Logs/MemberMaxWinLogs'
import MemberWalletLogs from '@/components/SideMenu/Logs/MemberWalletLogs'

// Affiliate
import AffiliateSetting from '@/components/SideMenu/Affiliate/AffiliateSetting'
import AffiliateList from '@/components/SideMenu/Affiliate/AffiliateList'
import AffiliateEstimateList from '@/components/SideMenu/Affiliate/AffiliateEstimateList'

// Mobile App
import MobileAppList from '@/components/SideMenu/MobileApp/MobileAppList'
// CRM
import SMSServiceProvider from '@/components/SideMenu/CRM/SMSServiceProvider'

//Crypto
import CryptoList from '@/components/SideMenu/Crypto/CryptoList'
import CryptoAccount from '@/components/SideMenu/Crypto/CryptoAccountList'
import MemberDepositCrypto from '@/components/SideMenu/Crypto/MemberDepositCrypto'
import MemberWithdrawalCrypto from '@/components/SideMenu/Crypto/MemberWithdrawalCrypto'
import MemberWalletList from '@/components/SideMenu/Crypto/MemberWalletList'
import CryptocurrencyStatement from '@/components/SideMenu/Crypto/CryptocurrencyStatement'
import CryptoTNC from '@/components/SideMenu/Crypto/CryptoTNC'
import CryptoTransaction from '@/components/SideMenu/Crypto/CryptoTransactionList'


//GG Earn
import MobileDashboard from '@/componentsGGEarn/Dashboard'
import MobileDashboardMonitoring from '@/componentsGGEarn/DashboardMonitoring'
import GGearnMember from '@/componentsGGEarn/SideMenu/GGearnMember'
import GGearnDownline from '@/componentsGGEarn/SideMenu/GGearnDownline'
import Support from '@/componentsGGEarn/SideMenu/Support'
import WithdrawCredit from '@/componentsGGEarn/SideMenu/WithdrawCredit'
import MobileProfile from '@/componentsGGEarn/Page/Profile'
import MobileNotifications from '@/componentsGGEarn/Page/Notifications'
import TermAndCondition from '@/componentsGGEarn/SideMenu/TermAndCondition'
import Guide from '@/componentsGGEarn/SideMenu/Guide'

Vue.use(Notifications)
Vue.use(Router)

let router;
if (isMarketingApp) {
    router = new Router({
        routes: [{
            path: '/',
            name: 'Dashboard MA',
            component: MobileDashboard,
            children: [

                //Dashboard
                {
                    path: '/DASH/DBM',
                    name: 'Dashboard Monitoring MA',
                    component: MobileDashboardMonitoring,
                    meta: { title: 'GGEarn - Dashboard Monitoring' }
                },
                {
                    path: '/W/WDU',
                    name: 'Withdraw',
                    component: WithdrawCredit,
                    meta: { title: 'GGEarn - Withdraw' }

                },
                {
                    path: '/EARN/M',
                    name: 'GGearn Member',
                    component: GGearnMember,
                    meta: { title: 'GGEarn - Member' }
                },
                {
                    path: '/EARN/D',
                    name: 'GGearn Downline',
                    component: GGearnDownline,
                    meta: { title: 'GGEarn - Downline' }
                },
                {
                    path: '/S/S',
                    name: 'Support',
                    component: Support,
                    meta: { title: 'GGEarn - Support' }
                },
                {
                    path: '/Profile',
                    name: 'Profile',
                    component: MobileProfile,
                    meta: { title: 'GGEarn - Profile' }
                },
                {
                    path: '/TNC',
                    name: 'TermAndCondition',
                    component: TermAndCondition,
                    meta: { title: 'GGEarn - Term And Conditions' }
                },
                {
                    path: '/GUIDE',
                    name: 'Guide',
                    component: Guide,
                    meta: { title: 'GGEarn - Guide' }
                },
                {
                    path: '/Notifications',
                    name: 'Notifications',
                    component: MobileNotifications,
                    meta: { title: 'GGEarn - Notifications' }
                },
            ]
        }],
        mode: 'history',
    });
}
else {
    router = new Router({
    routes: [{
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        children: [

            //Dashboard
            {
                path: '/DASH/DBM',
                name: 'Dashboard Monitoring',
                component: DashboardMonitoring,
                meta: { title: assignMeta(mainOEM)+' - Dashboard Monitoring' }
            },
            {
                path: '/DASH/DBO',
                name: 'Dashboard Operation',
                component: DashboardOperation,
                meta: { title: assignMeta(mainOEM)+' - Dashboard Operation' }

            },
            {
                path: '/DASH/DBP',
                name: 'Dashboard Performance',
                component: DashboardPerformance,
                meta: { title: assignMeta(mainOEM)+' - Dashboard Performance' }

            },
            {
                path: '/AN/AA',
                name: 'Active Annoucement SimplifyMenu',
                component: ActiveAnnoucement,
                meta: { title: assignMeta(mainOEM)+' - Active Annoucement' }
            },
            {
                path: '/DASH/AA',
                name: 'Active Annoucement',
                component: ActiveAnnoucement,
                meta: { title: assignMeta(mainOEM)+' - Active Annoucement' }

            },
            {
                path: '/DASH/CSO',
                name: 'CS Online',
                component: CSOnline,
                meta: { title: assignMeta(mainOEM)+' - CS Online' }

            },
            {
                path: '/DASH/DMMAL',
                name: 'Member Activities List',
                component: MemberActivitiesList,
                meta: { title: assignMeta(mainOEM)+' - Member Activities List' }

            },
            {
                path: '/DASH/MOL',
                name: 'Member Operation List',
                component: MemberOperationList,
                meta: { title: assignMeta(mainOEM)+' - Member Operation List' }

            },

            //Announcement
            {
                path: '/AN/SNT',
                name: 'System Notification',
                component: SystemNotification,
                meta: { title: assignMeta(mainOEM)+' - System Notification' }

            },
            {
                path: '/AN/MNT',
                name: 'Member Notification',
                component: MemberNotification,
                meta: { title: assignMeta(mainOEM)+' - Member Notification' }

            },
            {
                path: '/AN/SAN',
                name: 'System Announcement',
                component: SystemAnnouncement,
                meta: { title: assignMeta(mainOEM)+' - System Announcement' }

            },
            {
                path: '/AN/MAN',
                name: 'Member Announcement',
                component: MemberAnnouncement,
                meta: { title: assignMeta(mainOEM)+' - Member Announcement' }

            },


            //Member
            {
                path: '/M/ML',
                name: 'Member List',
                component: MemberList,
                meta: { title: assignMeta(mainOEM)+' - Member List' }

            },
            {
                path: '/M/ML/CheckingMember',
                name: 'Checking Member',
                component: Sub_CheckingMember,
                meta: { title: assignMeta(mainOEM) +' - Checking Member Profile' }

            },
            {
                path: '/M/ML/SameTransactionIP',
                name: 'Same Transaction IP Member',
                component: Sub_SameTransactionIP,
                meta: { title: assignMeta(mainOEM)+' - Same Transaction IP Member' }

            },
            {
                path: '/M/ML/SamePromotionIP',
                name: 'Same Promotion IP Member',
                component: Sub_SamePromotionIP,
                meta: { title: assignMeta(mainOEM)+' - Same Promotion IP Member' }

            },
            {
                path: '/M/MCMI',
                name: 'Check Member Info',
                component: MemberInfo,
                meta: { title: assignMeta(mainOEM)+' - Check Member' }

            },
            {
                path: '/M/MO',
                name: 'Member Online',
                component: MemberOnline,
                meta: { title: assignMeta(mainOEM)+' - Member Online' }

            },

            {
                path: '/M/BLL',
                name: 'Black List',
                component: BlackList,
                meta: { title: assignMeta(mainOEM)+' - Black / Freeze Member' }

            },
            {
                path: '/M/MTS',
                name: 'Member Type',
                component: MemberType,
                meta: { title: assignMeta(mainOEM)+' - Member Type' }

            },
            {
                path: '/M/MBA',
                name: 'Member Balance Adjustment',
                component: MemberBalanceAdjustment,
                meta: { title: assignMeta(mainOEM)+' - Balance Adjustment' }

            },
            //Agent



            //ContentManagementSystem
            {
                path: '/CMS/BA',
                name: 'Banner',
                component: Banner,
                meta: { title: assignMeta(mainOEM)+' - Banner' }

            },
            {
                path: '/WEBS/BA',
                name: 'Banner SimplifyMenu',
                component: Banner,
                meta: { title: assignMeta(mainOEM)+' - Banner' }

            },
            {
                path: '/CMS/CMSDU',
                name: 'Customize Menu',
                component: FooterMenu,
                meta: { title: assignMeta(mainOEM)+' - Customize Website Menu' }

            },
            {
                path: '/WEBS/CMSDU',
                name: 'Customize Menu SimplifyMenu',
                component: FooterMenu,
                meta: { title: assignMeta(mainOEM)+' - Customize Website Menu' }

            },
            {
                path: '/CMS/LC',
                name: 'Live Chat',
                component: LiveChat,
                meta: { title: assignMeta(mainOEM)+' - Live Chat' }

            },
            {
                path: '/WEBS/LC',
                name: 'Live Chat SimplifyMenu',
                component: LiveChat,
                meta: { title: assignMeta(mainOEM)+' - Live Chat' }

            },
            {
                path: '/CMS/QRC',
                name: 'QR code',
                component: QRcode,
                meta: { title: assignMeta(mainOEM)+' - Mobile App' }

            },
            {
                path: '/WEBS/QRC',
                name: 'QR code SimplifyMenu',
                component: QRcode,
                meta: { title: assignMeta(mainOEM)+' - Mobile App' }

            },
            {
                path: '/CMS/SM',
                name: 'Social Media',
                component: SocialMedia,
                meta: { title: assignMeta(mainOEM)+' - Social Media' }

            },
            {
                path: '/WEBS/SM',
                name: 'Social Media SimplifyMenu',
                component: SocialMedia,
                meta: { title: assignMeta(mainOEM)+' - Social Media' }

            },
            {
                path: '/CMS/FC',
                name: 'Footer Conetnt',
                component: FooterContent,
                meta: { title: assignMeta(mainOEM)+' - Footer Content' }

            },
            {
                path: '/WEBS/FC',
                name: 'Footer Conetnt SimplifyMenu',
                component: FooterContent,
                meta: { title: assignMeta(mainOEM)+' - Footer Content' }

            },
            {
                path: '/CMS/PV',
                name: 'Promotional Video',
                component: PromotionalVideo,
                meta: { title: assignMeta(mainOEM)+' - Pop-Up' }

            },
            {
                path: '/WEBS/PV',
                name: 'Promotional Video SimplifyMenu',
                component: PromotionalVideo,
                meta: { title: assignMeta(mainOEM)+' - Pop-Up' }

            },
            {
                path: '/CMS/CS',
                name: 'Contact Settings',
                component: ContactSettings,
                meta: { title: assignMeta(mainOEM)+' - Contact Settings' }

            },
            {
                path: '/WEBS/CS',
                name: 'Contact Settings SimplifyMenu',
                component: ContactSettings,
                meta: { title: assignMeta(mainOEM)+' - Contact Settings' }

            },
            {
                path: '/CMS/NE',
                name: 'News',
                component: News,
                meta: { title: assignMeta(mainOEM)+' - News Feed' }

            },
            {
                path: '/WEBS/NE',
                name: 'News SimplifyMenu',
                component: News,
                meta: { title: assignMeta(mainOEM)+' - News Feed' }

            },
            //Marketing
            {
                path: '/MS/S',
                name: 'SEOS',
                component: SEOS,
                meta: { title: assignMeta(mainOEM)+' - SEO' }

            },
            {
                path: '/WEBS/S',
                name: 'SEOS SimplifyMenu',
                component: SEOS,
                meta: { title: assignMeta(mainOEM)+' - SEO' }

            },
            {
                path: '/MS/WT',
                name: 'Webmaster Tools',
                component: WebmasterTools,
                meta: { title: assignMeta(mainOEM)+' - Webmaster Tools' }

            },
            {
                path: '/WEBS/WT',
                name: 'Webmaster Tools SimplifyMenu',
                component: WebmasterTools,
                meta: { title: assignMeta(mainOEM)+' - Webmaster Tools' }

            },
            {
                path: '/MS/HFS',
                name: 'Header Footer Scripts',
                component: HeaderFooterScripts,
                meta: { title: assignMeta(mainOEM)+' - Header & Footer Scripts' }

            },
            {
                path: '/WEBS/HFS',
                name: 'Header Footer Scripts SimplifyMenu',
                component: HeaderFooterScripts,
                meta: { title: assignMeta(mainOEM)+' - Header & Footer Scripts' }

            },
            {
                path: '/MS/RS',
                name: 'Register Source',
                component: RegisterSource,
                meta: { title: assignMeta(mainOEM)+' - Register Source Setting' }

            },
            {
                path: '/AFF/RS',
                name: 'Register Source SimplifyMenu',
                component: RegisterSource,
                meta: { title: assignMeta(mainOEM)+' - Register Source Setting' }

            },
            {
                path: '/MS/LPS',
                name: 'Loyalty Program Setting',
                component: LoyaltyProgram,
                meta: { title: assignMeta(mainOEM)+' - Loyalty Program Setting' }

            },
            {
                path: '/AFF/LPS',
                name: 'Loyalty Program Setting SimplifyMenu',
                component: LoyaltyProgram,
                meta: { title: assignMeta(mainOEM)+' - Loyalty Program Setting' }

            },

            //Bank
            {
                path: '/B/BB',
                name: 'Bank Balance',
                component: BankBalance,
                meta: { title: assignMeta(mainOEM)+' - Bank Balance' }

            },
            {
                path: '/B/TD',
                name: 'Transaction Details',
                component: TransactionDetails,
                meta: { title: assignMeta(mainOEM)+' - Transaction Details' }

            },
            {
                path: '/B/BL',
                name: 'Bank List',
                component: BankList,
                meta: { title: assignMeta(mainOEM)+' - Bank List' }

            },
            {
                path: '/B/ACL',
                name: 'Account List',
                component: AccountList,
                meta: { title: assignMeta(mainOEM)+' - Account List' }

            },
            {
                path: '/B/CR',
                name: 'Currency & Rates',
                component: CurrencyRates,
                meta: { title: assignMeta(mainOEM)+' - Currency & Rates' }

            },
            {
                path: '/B/MDB',
                name: 'Member Deposit Bank',
                component: MemberDepositBank,
                meta: { title: assignMeta(mainOEM)+' - Member Deposit Bank' }

            },
            {
                path: '/B/MWB',
                name: 'Member Withdrawal Bank',
                component: MemberWithdrawalBank,
                meta: { title: assignMeta(mainOEM)+' - Member Withdrawal Bank' }

            },
            {
                path: '/B/BankStatement',
                name: 'Bank Satement',
                component: BankStatement,
                meta: { title: assignMeta(mainOEM)+' - Bank Satement' }

            },
            {
                path: '/B/RCS',
                name: 'Report Currency Setting',
                component: ReportCurrencySetting,
                meta: { title: assignMeta(mainOEM) + ' - Report Currency Setting' }

            },
            //Deposit
            {
                path: '/D/DDU',
                name: 'Deposit',
                component: Deposit,
                meta: { title: assignMeta(mainOEM)+' - Pending Deposit' }

            },
            {
                path: '/D/MD',
                name: 'Manual Deposit',
                component: ManualDeposit,
                meta: { title: assignMeta(mainOEM)+' - Manual Deposit' }

            },
            {
                path: '/D/DR',
                name: 'Deposit Report',
                component: DepositReport,
                meta: { title: assignMeta(mainOEM) +' - Deposit Report' }

            },

            //Withdraw
            {
                path: '/W/WDU',
                name: 'Withdraw',
                component: Withdraw,
                meta: { title: assignMeta(mainOEM)+' - Pending Withdrawal' }

            },
            {
                path: '/W/MW',
                name: 'Manual Withdraw',
                component: ManualWithdraw,
                meta: { title: assignMeta(mainOEM)+' - Manual Withdraw' }

            },
            {
                path: '/W/WR',
                name: 'Withdrawal Report',
                component: WithdrawReport,
                meta: { title: assignMeta(mainOEM) +' - Withdrawal Report' }

            },
            {
                path: '/W/SWR',
                name: 'Sub Agent Withdrawal Report',
                component: SubAgentWithdrawReport,
                meta: { title: assignMeta(mainOEM)+' - Sub Agent Withdrawal' }

            },
            {
                path: '/W/SWDU',
                name: 'SubAgentWithdraw',
                component: SubAgentWithdraw,
                meta: { title: assignMeta(mainOEM)+' - Pending Sub Agent Withdrawal' }

            },
            {
                path: '/W/SMW',
                name: 'Sub Agent Manual Withdraw',
                component: SubAgentManualWithdraw,
                meta: { title: assignMeta(mainOEM) + ' - Sub Agent Manual Withdraw' }

            },

            //Promotion
            {
                path: '/P/PDU',
                name: 'Promotion',
                component: Promotion,
                meta: { title: assignMeta(mainOEM)+' - Pending Promotion' }

            },
            {
                path: '/P/LYT',
                name: 'Loyalty',
                component: Loyalty,
                meta: { title: assignMeta(mainOEM)+' - Auto Rebate' }

            },
            {
                path: '/P/MP',
                name: 'Manual Promotion',
                component: ManualPromotion,
                meta: { title: assignMeta(mainOEM)+' - Manual Promotion' }

            },           
            {
                path: '/P/PMCR',
                name: 'Manual Cashback Rebate Promotion',
                component: ManualCashbackRebatePromotion,
                meta: { title: assignMeta(mainOEM)+' - Manual Cashback / Rebate' }

            },            
            {
                path: '/P/PSE',
                name: 'Promotion Campaign',
                component: PromotionSettings,
                meta: { title: assignMeta(mainOEM)+' - Promotion Setup' }

            },
            {
                path: '/P/PD',
                name: 'Promotion Publishing',
                component: PromotionDesign,
                meta: { title: assignMeta(mainOEM)+' - Promotion Publishing' }

            },
            {
                path: '/P/PAP',
                name: 'Active Promotion',
                component: ActivePromotion,
                meta: { title: assignMeta(mainOEM)+' - Members On Active Promotion' }
            },
            {
                path: '/M/PAP',
                name: 'Active Promotion SimplifyMenu',
                component: ActivePromotion,
                meta: { title: assignMeta(mainOEM)+' - Members On Active Promotion' }

            },
            {
                path: '/P/DLSP',
                name: 'Daily Lucky Spin Promotion',
                component: DLSPromotion,
                meta: { title: assignMeta(mainOEM)+' - Daily Lucky Spin Promotion' }

            },
            {
                path: '/P/DLSS',
                name: 'Daily Lucky Spin Setting',
                component: DLSSetting,
                meta: { title: assignMeta(mainOEM)+' - Daily Lucky Spin Setting' }

            },
            {
                path: '/P/TNMT',
                name: 'Tournament Setting',
                component: Tournament,
                meta: { title: assignMeta(mainOEM)+' - Tournament Setting' }

            },
            {
                path: '/P/PRS',
                name: 'Promotion Rules',
                component: PromotionRules,
                meta: { title: assignMeta(mainOEM)+' - Promotion Rules' }

            },
            {
                path: '/P/MSA',
                name: 'PrizeDrop',
                component: Mission,
                meta: { title: assignMeta(mainOEM)+' - Prize Drop Setup' }

            },
            {
                path: '/P/PPS',
                name: 'Prize Pool Setup',
                component: PrizePoolSetup,
                meta: { title: assignMeta(mainOEM) + ' - Prize Pool Setup' }
            },
            {
                path: '/P/RWS',
                name: 'Reward Setup',
                component: RewardSetup,
                meta: { title: assignMeta(mainOEM) + ' - Reward Setup' }
            },

            //GameSettings
            {
                path: '/GS/GL',
                name: 'Game List',
                component: GameList,
                meta: { title: assignMeta(mainOEM)+' - Game List Config' }

            },
            {
                path: '/GS/GLCBA',
                name: 'Game List Config By Agent',
                component: GameListConfigByAgent,
                meta: { title: assignMeta(mainOEM)+' - Game List Config By Agent' }

            },
            {
                path: '/GS/GSDU',
                name: 'Settings',
                component: GameSettings,
                meta: { title: assignMeta(mainOEM)+' - Game Settings' }

            },
            {
                path: '/GS/T5G',
                name: 'Top 5 Games',
                component: Top5Game,
                meta: { title: assignMeta(mainOEM)+' - Game Ranking' }

            },
            {
                path: '/GS/T5GP',
                name: 'Top 5 Game Providers',
                component: Top5GameProviders,
                meta: { title: assignMeta(mainOEM)+' - Game Providers Ranking' }

            },
            {
                path: '/GS/GPS',
                name: 'Game Providers Setting',
                component: GameProvidersSetting,
                meta: { title: assignMeta(mainOEM)+' - Poker V Setting' }

            },
            {
                path: '/GS/GMC',
                name: 'Mass Config',
                component: GameMassConfig,
                meta: { title: assignMeta(mainOEM)+' - Mass Config' }
            },
            {
                path: '/GS/M888S',
                name: 'Mega888 Setting',
                component: Mega888Setting,
                meta: { title: assignMeta(mainOEM)+' - Mega888 Setting' }

            },
            {
                path: '/GS/MV3S',
                name: 'MegaV3 Setting',
                component: MegaV3Setting,
                meta: { title: assignMeta(mainOEM)+' - MegaV3 Setting' }

            },
            {
                path: '/GS/A288S',
                name: 'AFB288 Setting',
                component: AFB288Setting,
                meta: { title: assignMeta(mainOEM)+' - AFB288 Setting' }

            },
            {
                path: '/GS/P888S',
                name: 'Pussy888 Setting',
                component: Pussy888Setting,
                meta: { title: assignMeta(mainOEM)+' - Pussy888 Setting' }

            },
            {
                path: '/GS/K918S',
                name: 'Kiss918 Setting',
                component: Kiss918Setting,
                meta: { title: assignMeta(mainOEM)+' - 918Kiss Setting' }

            },
            {
                path: '/GS/AFBCS',
                name: 'AFBCasino Setting',
                component: AFBCasinoSetting,
                meta: { title: assignMeta(mainOEM)+' - AFBCasino Setting' }

            },
            {
                path: '/GS/LG88S',
                name: 'LG88 Setting',
                component: LG88Setting,
                meta: { title: assignMeta(mainOEM)+' - LG88 Setting' }

            },
            {
                path: '/GS/GD88S',
                name: 'GD88 Setting',
                component: GD88Setting,
                meta: { title: assignMeta(mainOEM)+' - GD88 Setting' }

            },
            {
                path: '/GS/NKS',
                name: 'New Keno Setting',
                component: NewKenoSetting,
                meta: { title: assignMeta(mainOEM)+' - New Keno Setting' }

            },
            //{
            //    path: '/GS/DG3DS',
            //    name: 'DG3D Setting',
            //    component: DG3DSetting,
            //    meta: { title: assignMeta(mainOEM)+' - DG3D Setting' }
            //
            //},
            {
                path: '/GS/W9S',
                name: '9Wicket Setting',
                component: Wriket9Setting,
                meta: { title: assignMeta(mainOEM) +' - 9Wicket Setting' }

            },
            {
                path: '/GS/GPLCBA',
                name: 'Game Provider List Config By Agent',
                component: GameProviderListConfigByAgent,
                meta: { title: assignMeta(mainOEM)+' - Game Provider List Config By Agent' }

            },
            {
                path: '/AGS/GPLCBA',
                name: 'Game Provider List Config By Agent SimplifyMenu',
                component: GameProviderListConfigByAgent,
                meta: { title: assignMeta(mainOEM) + ' - Game Provider List Config By Agent' }

            },
            {
                path: '/GS/GPSUB',
                name: 'Game Providers By Sub-Agent',
                component: GameProviderBySubAgent,
                meta: { title: assignMeta(mainOEM)+' - Game Providers By Sub-Agent' }

            },
            {
                path: '/AGS/GPSUB',
                name: 'Game Providers By Sub-Agent SimplifyMenu',
                component: GameProviderBySubAgent,
                meta: { title: assignMeta(mainOEM) + ' - Game Providers By Sub-Agent' }

            },
            {
                path: '/GS/GLU',
                name: 'Game Launch URL',
                component: GameLaunchUrl,
                meta: { title: assignMeta(mainOEM)+' - Game Launch URL' }

            },
            {
                path: '/GS/IGS',
                name: 'IG Lottery Setting',
                component: IGLotterySetting,
                meta: { title: assignMeta(mainOEM)+' - IG Lottery Setting' }

            },
            {
                path: '/AGS/GAS',
                name: 'Game Attribute Setting SimplifyMenu',
                component: GameAttributeSetting,
                meta: { title: assignMeta(mainOEM) + ' - Game Attribute Setting' }
            },
            {
                path: '/WEBS/GAS',
                name: 'Game Attribute Setting',
                component: GameAttributeSetting,
                meta: { title: assignMeta(mainOEM) + ' - Game Attribute Setting' }
            },

            //Reports
            {
                path: '/R/TWL',
                name: 'Total Win Loss',
                component: TotalWinLoss,
                meta: { title: assignMeta(mainOEM)+' - Gross Win Loss' }

            },
            //{
            //    path: '/R/WINL',
            //    name: 'Win Loss',
            //    component: WinLoss,
            //    meta: { title: assignMeta(mainOEM)+' - Win Loss Ticket' }

            //},
            {
                path: '/R/WINLV2',
                name: 'Win Loss V2',
                component: WinLossV2,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Ticket' }

            },
            {
                path: '/R/DR2',
                name: 'Deposit Report',
                component: DepositReport,
                meta: { title: assignMeta(mainOEM)+' - Deposit' }

            },
            {
                path: '/R/BTL',
                name: 'Bet List',
                component: BetList,
                meta: { title: assignMeta(mainOEM)+' - Bet List' }

            },
            {
                path: '/R/WR2',
                name: 'Withdraw Report',
                component: WithdrawReport,
                meta: { title: assignMeta(mainOEM) +' - Withdraw' }

            },
            {
                path: '/R/FR',
                name: 'Finance Report',
                component: FinanceReport,
                meta: { title: assignMeta(mainOEM)+' - Finance Report' }

            },
            {
                path: '/R/TR',
                name: 'Turnover Report',
                component: TurnoverReport,
                meta: { title: assignMeta(mainOEM)+' - Turnover' }

            },
            {
                path: '/R/PR',
                name: 'Promotion Report',
                component: PromotionReport,
                meta: { title: assignMeta(mainOEM)+' - Promotion' }

            },
            {
                path: '/R/APTR',
                name: 'Position Taking Report',
                component: PositionTaking,
                meta: { title: assignMeta(mainOEM)+' - Position Taking' }

            },
            {
                path: '/R/DCSR',
                name: 'Daily CS Report',
                component: DailyCSReport,
                meta: { title: assignMeta(mainOEM)+' - Daily CS' }

            },
            {
                path: '/R/LR',
                name: 'Loyalty Programme Report',
                component: LoyaltyProgrammeReport,
                meta: { title: assignMeta(mainOEM)+' - Auto Rebate' }

            },
            {
                path: '/R/TWLBP',
                name: 'Total Win Loss By Provider',
                component: TotalWinLossByProvider,
                meta: { title: assignMeta(mainOEM)+' - Win Loss by Provider' }

            },
            {
                path: '/R/TWLBAG',
                name: 'Total Win Loss By AG',
                component: TotalWinLossByAG,
                meta: { title: assignMeta(mainOEM)+' - Net Win Loss' }

            },
            {
                path: '/R/TWLBSA',
                name: 'Total Win Loss By SA',
                component: TotalWinLossBySA,
                meta: { title: assignMeta(mainOEM)+' - Win Loss by SM' }

            },
            {
                path: '/R/TWLBMA',
                name: 'Total Win Loss By MA',
                component: TotalWinLossByMA,
                meta: { title: assignMeta(mainOEM)+' - Win Loss by MA' }

            },
            {
                path: '/R/TWLBMAD',
                name: 'Total Win Loss By MA Detail',
                component: TotalWinLossByMADetail,
                meta: { title: assignMeta(mainOEM)+' - Win Loss by MA Detail' }

            },
            //{
            //    path: '/R/TWLBMEM',
            //    name: 'Total Win Loss By Member',
            //    component: TotalWinLossByMember,
            //    meta: { title: assignMeta(mainOEM)+' - Total Win Loss By Members' }

            //},
            {
                path: '/R/TWLBMEM2',
                name: 'Total Win Loss By Member 2',
                component: TotalWinLossByMember2,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Member' }

            },
            {
                path: '/R/AFFR',
                name: 'Affiliate Report',
                component: AffiliateReport,
                meta: { title: assignMeta(mainOEM)+' - Referral' }

            },
            {
                path: '/R/DLSR',
                name: 'Daily Lucky Spin Report',
                component: DLSReport,
                meta: { title: assignMeta(mainOEM)+' - Daily Lucky Spin' }

            },
            {
                path: '/R/RWDR',
                name: 'Reward Report',
                component: RewardReport,
                meta: { title: assignMeta(mainOEM) + ' - Reward' }

            },
            {
                path: '/R/A1188FR',
                name: 'AFB1188 Forecast Report',
                component: AFB1188Forecast,
                meta: { title: assignMeta(mainOEM)+' - Sports Forecast' }

            },
            {
                path: '/R/RSR',
                name: 'Register Source Report',
                component: RegisterSourceReport,
                meta: { title: assignMeta(mainOEM)+' - Register Source' }

            },
            {
                path: '/R/NTWL',
                name: 'New Total Win Loss',
                component: NewTotalWinLoss,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Agent' }

            },
            {
                path: '/R/SAGTWL',
                name: 'Total Win Loss Sub Agent',
                component: TotalWinLossSubAgent,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Sub-Agent' }
            },
            {
                path: '/R/SAGTWLD',
                name: 'Total Win Loss Sub Agent Detail',
                component: TotalWinLossSubAgentDetail,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Sub Agent Detail' }
            },
            {
                path: '/R/CPR/CPRD',
                name: 'Cash Position Detail',
                component: Sub_CashPosition,
                meta: { title: assignMeta(mainOEM)+' - Cash Position Report Detail' }

            },
            {
                path: '/R/CPR',
                name: 'Cash Position Report',
                component: CashPosition,
                meta: { title: assignMeta(mainOEM)+' - Cash Position' }

            },
            {
                path: '/R/WLADJ',
                name: 'W/L Adjustment',
                component: WLAdjustment,
                meta: { title: assignMeta(mainOEM)+' - Win Loss Adjustment' }

            },
            {
                path: '/R/BALADJRPT',
                name: 'Bal Adj Report',
                component: BALADJRPT,
                meta: { title: assignMeta(mainOEM)+' - Balance Adjustment' }

            },
            {
                path: '/R/USTR',
                name: 'Unsettled Tickets',
                component: USTR,
                meta: { title: assignMeta(mainOEM)+' - Unsettled Tickets' }

            },
            {
                path: '/R/PLMEM',
                name: 'P&L Member',
                component: PLMember,
                meta: { title: assignMeta(mainOEM)+' - P&L Member' }


            },
            {
                path: '/R/PLBRAN',
                name: 'P&L Branch',
                component: PLBranch,
                meta: { title: assignMeta(mainOEM)+' - P&L Branch' }

            },
            {
                path: '/R/TAS',
                name: 'Total Agent Summary',
                component: TotalAgentSummary,
                meta: { title: assignMeta(mainOEM)+' - Total Agent Summary' }
            },
            {
                path: '/R/ABRBM',
                name: 'AFB1188 Bet Report By Match',
                component: AFB1188BetReportByMatch,
                meta: { title: assignMeta(mainOEM)+' - Sports by Match' }
            },
            {
                path: '/R/TNMTR',
                name: 'TournamentReport',
                component: TournamentReport,
                meta: { title: assignMeta(mainOEM)+' - Tournament Report' }
            },
            {
                path: '/R/TNMTSR',
                name: 'TournamentSettlementReport',
                component: TournamentSettlementReport,
                meta: { title: assignMeta(mainOEM)+' - Event Settlement' }
            },
            {
                path: '/R/TNMTCR',
                name: 'TournamentCurrentRanking',
                component: TournamentCurrentRanking,
                meta: { title: assignMeta(mainOEM)+' - Tournament Current Ranking' }
            },
            {
                path: '/R/MSAR',
                name: 'PrizeDropReport',
                component: MissionReport,
                meta: { title: assignMeta(mainOEM)+' - Prize Drop' }
            },
            {
                path: '/R/EBD',
                name: 'Expenses Breakdown',
                component: ExpenseBreakdown,
                meta: { title: assignMeta(mainOEM)+' - Expenses Breakdown' }

            },
            {
                path: '/R/PEP',
                name: 'Provider Event Payout',
                component: ProviderEventPayout,
                meta: { title: assignMeta(mainOEM)+' - Provider Event Payout' }
            },
            {
                path: '/R/PBSAR',
                name: 'Promotion By Sub Agent',
                component: PromotionBySubAgent,
                meta: { title: assignMeta(mainOEM)+' - Promotion By Sub Agent' }
            },
            {
                path: '/R/ACM',
                name: 'Account Report',
                component: AccountingReport,
                meta: { title: assignMeta(mainOEM)+' - Account Report' }
            },
            {
                path: '/R/MTF',
                name: 'Maintenance Report',
                component: MaintenanceReport,
                meta: { title: assignMeta(mainOEM) + ' - Maintenance Report' }
            },
            {
                path: '/R/OST',
                name: 'Outstanding Report',
                component: OutstandingReport,
                meta: { title: assignMeta(mainOEM) + ' - Outstanding Report' }
            },
            {
                path: '/R/OVW',
                name: 'Overview Report',
                component: OverviewReport,
                meta: { title: assignMeta(mainOEM) + ' - Overview Report' }
            },
            {
                path: '/R/OTPR',
                name: 'OTP Report',
                component: OTPReport,
                meta: { title: assignMeta(mainOEM) + ' - OTP Report' }
            },
            //AGENT SETTING
            {
                path: '/AGS/CRB',
                name: 'Manage Brand',
                component: CreateBrand,
                meta: { title: assignMeta(mainOEM)+' - Manage Agent' }

            },
            {
                path: '/AGS/CRB2',
                name: 'Manage Downline',
                component: CreateBrand2,
                meta: { title: assignMeta(mainOEM)+' - Manage Downline' }

            },
            {
                path: '/AGS/CRD',
                name: 'Manage Domain',
                component: CreateDomain,
                meta: { title: assignMeta(mainOEM)+' - Manage Domain' }
            },
            {
                path: '/WEBS/CRD',
                name: 'Manage Domain SimplifyMenu',
                component: CreateDomain,
                meta: { title: assignMeta(mainOEM)+' - Manage Domain' }
            },
            {
                path: '/AGS/CRD2',
                name: 'Manage Domain 2',
                component: CreateDomain2,
                meta: { title: assignMeta(mainOEM)+' - Manage Domain' }

            },
            {
                path: '/WEBS/CRD2',
                name: 'Manage Domain 2 SimplifyMenu',
                component: CreateDomain2,
                meta: { title: assignMeta(mainOEM) + ' - Manage Domain' }

            },
            {
                path: '/AGS/APTRS',
                name: 'Position Taking',
                component: PositionTakingSettingNew,
                meta: { title: assignMeta(mainOEM)+' - Position Taking' }

            },
            // {
            //     path: '/AGS/APTRS2',
            //     name: 'Position Taking New',
            //     component: PositionTakingSettingNew,
            //     meta: { title: assignMeta(mainOEM)+' - Position Taking' }

            // },
            {
                path: '/AGS/ACUZ',
                name: 'Agent Customization',
                component: AgentCustomize,
                meta: { title: assignMeta(mainOEM)+' - Website Config' }

            },
            {
                path: '/WEBS/ACUZ',
                name: 'Agent Customization SimplifyMenu',
                component: AgentCustomize,
                meta: { title: assignMeta(mainOEM)+' - Website Config' }

            },
            {
                path: '/AGS/DCUZ',
                name: 'Deposit Customization',
                component: DepositCustomize,
                meta: { title: assignMeta(mainOEM)+' - Customize Deposit' }

            },
            {
                path: '/WEBS/DCUZ',
                name: 'Deposit Customization SimplifyMenu',
                component: DepositCustomize,
                meta: { title: assignMeta(mainOEM)+' - Customize Deposit' }

            },
            {
                path: '/AGS/RCUZ',
                name: 'Register Customization',
                component: RegisterCustomize,
                meta: { title: assignMeta(mainOEM)+' - Customize Register' }

            },
            {
                path: '/WEBS/RCUZ',
                name: 'Register Customization SimplifyMenu',
                component: RegisterCustomize,
                meta: { title: assignMeta(mainOEM)+' - Customize Register' }

            },

            {
                path: '/AGS/AHRY',
                name: 'Agent Hierarchy',
                component: AgentHierarchy,
                meta: { title: assignMeta(mainOEM)+' - Agent Hierarchy' }

            },
            {
                path: '/AGS/BalanceHistory',
                name: 'Balance History',
                component: BalanceHistory,
                meta: { title: assignMeta(mainOEM)+' - System Balance History' }

            },
            {
                path: '/AGS/FGP',
                name: 'FingerPrint',
                component: FingerPrint,
                meta: { title: assignMeta(mainOEM)+' - System ID' }
            },
            {
                path: '/AGS/SUB',
                name: 'Manage Sub Agent',
                component: CreateSubAgent,
                meta: { title: assignMeta(mainOEM)+' - Sub Agent Setting' }
            },
            {
                path: '/AGS/SUBC',
                name: 'Sub Agent Candidiate',
                component: CreateSubAgentCandidate,
                meta: { title: assignMeta(mainOEM)+' - Sub Agent Candidate' }
            },
            {
                path: '/AGS/SubAgentCreditHistory',
                name: 'Sub Agent Credit History',
                component: SubAgentCreditHistory
            },
            {
                path: '/AGS/SUBHRY',
                name: 'SubAgent Hierarchy',
                component: SubAgentHierarchy,
                meta: { title: assignMeta(mainOEM)+' - Sub-Agent Hierarchy' }

            },
            {
                path: '/AGS/TemplateSkin',
                name: 'Template Skin Details',
                component: TemplateSkinDetails,
                meta: { title: assignMeta(mainOEM)+' - Template Skin Details' }
            },
            {
                path: '/AGS/ASS',
                name: 'Agent SelfService',
                component: AgentSelfService,
                meta: { title: assignMeta(mainOEM)+' - Agent SelfService' }
            },
            {
                path: '/AGS/AGD',
                name: 'Agent Dashboard',
                component: AgentDashboard,
                meta: { title: assignMeta(mainOEM)+' - Self Service Agent' }
            },
            {
                path: '/AGS/RFFR',
                name: 'Resend Failed Free Rounds',
                component: ResendFailedFreeRounds,
                meta: { title: assignMeta(mainOEM)+' - Resend Free Rounds' }
            },
            {
                path: '/P/RFFR',
                name: 'Resend Failed Free Rounds SimplifyMenu',
                component: ResendFailedFreeRounds,
                meta: { title: assignMeta(mainOEM)+' - Resend Free Rounds' }
            },
            // SystemSettings

            {

                path: '/SYS/CRR',
                name: 'Manage System Role',
                component: CreateRole,
                meta: { title: assignMeta(mainOEM)+' - Manage Role' }

            },
            {
                path: '/SYS/AL',
                name: 'Agent List',
                component: AgentList,
                meta: { title: assignMeta(mainOEM)+' - Manage User' }

            },
            //Logs
            {
                path: '/L/ALO',
                name: 'Agent Logs',
                component: AgentLogs,
                meta: { title: assignMeta(mainOEM)+' - Agent' }

            },
            {
                path: '/L/MLO',
                name: 'Member Logs',
                component: MemberLogs,
                meta: { title: assignMeta(mainOEM)+' - Member' }

            },
            {
                path: '/L/DL',
                name: 'Deposit Logs',
                component: DepositLogs,
                meta: { title: assignMeta(mainOEM)+' - Deposit' }

            },
            {
                path: '/L/WL',
                name: 'Withdraw Logs',
                component: WithdrawLogs,
                meta: { title: assignMeta(mainOEM)+' - Withdrawal' }

            },
            {
                path: '/L/PL',
                name: 'Promotion Logs',
                component: PromotionLogs,
                meta: { title: assignMeta(mainOEM)+' - Promotion' }

            },
            {
                path: '/L/VLO',
                name: 'Visitor Logs',
                component: VisitorLogs,
                meta: { title: assignMeta(mainOEM)+' - System ID' }

            },
            {
                path: '/L/BAL',
                name: 'Balace Adjustment Logs',
                component: BalAdjLogs,
                meta: { title: assignMeta(mainOEM)+' - Balace Adjustment' }

            },
            {
                path: '/L/MMWL',
                name: 'Member Max Win Logs',
                component: MemberMaxWinLogs,
                meta: { title: assignMeta(mainOEM)+' - Max Win' }

            },
            {
                path: '/L/MEMWL',
                name: 'Member Wallet Logs',
                component: MemberWalletLogs,
                meta: { title: assignMeta(mainOEM)+' - Wallet' }

            },


            {
                path: '/AFF/AFFS',
                name: 'Affiliate Setting',
                component: AffiliateSetting,
                meta: { title: assignMeta(mainOEM)+' - Referral Setting' }

            },
            {
                path: '/AFF/AFFEL',
                name: 'Affiliate Estimate List',
                component: AffiliateEstimateList,
                meta: { title: assignMeta(mainOEM)+' - Referral Payout' }

            },
            {
                path: '/AFF/AFFL',
                name: 'Affiliate List',
                component: AffiliateList,
                meta: { title: assignMeta(mainOEM)+' - Referral List' }
            },
           
            // Top right
            {
                path: '/Profile',
                name: 'Profile',
                component: Profile,
                meta: { title: assignMeta(mainOEM)+' - Profile Settings' }

            },
            {
                path: '/CustomizeMenu',
                name: 'CustomizeMenu',
                component: CustomizeMenu,
                meta: { title: assignMeta(mainOEM) + ' - Customize Menu' }

            },
            {
                path: '/Notifications',
                name: 'Notifications',
                component: Page_Notifications,
                meta: { title: assignMeta(mainOEM)+' - Notification' }

            },
            // Mobile App
            {
                path: '/MAPP/MAPPL',
                name: 'Mobile App List',
                component: MobileAppList,
                meta: { title: assignMeta(mainOEM)+' - Mobile App List' }

            },
            // CRM
            {
                path: '/CRM/SMSSP',
                name: 'SMS Service Provider',
                component: SMSServiceProvider,
                meta: { title: assignMeta(mainOEM)+' - SMS Service Provider' }

            },
            // Crypto
            {
                path: '/C/CL',
                name: 'Crypto List',
                component: CryptoList,
                meta: { title: assignMeta(mainOEM)+' - Coin List' }

            },
            {
                path: '/C/CAL',
                name: 'Crypto Account',
                component: CryptoAccount,
                meta: { title: assignMeta(mainOEM)+' - Account Setting' }

            },
            {
                path: '/C/MDC',
                name: 'Member Deposit Crypto',
                component: MemberDepositCrypto,
                meta: { title: assignMeta(mainOEM)+' - Member Deposit Account' }

            },
            {
                path: '/C/MWC',
                name: 'Member Withdrawal Crypto',
                component: MemberWithdrawalCrypto,
                meta: { title: assignMeta(mainOEM)+' - Member Withdraw Account' }

            },
            {
                path: '/C/MWL',
                name: 'Member Wallet List',
                component: MemberWalletList,
                meta: { title: assignMeta(mainOEM)+' - Agent Withdrawal' }

            },
            {
                path: '/C/CTS',
                name: 'Crypto Statement',
                component: CryptocurrencyStatement,
                meta: { title: assignMeta(mainOEM)+' - Transaction History' }

            },
            {
                path: '/C/TNC',
                name: 'Terms And Conditions',
                component: CryptoTNC,
                meta: { title: assignMeta(mainOEM)+' - Terms And Conditions' }

            },
            {
                path: '/C/CTL',
                name: 'Crypto Transaction',
                component: CryptoTransaction,
                meta: { title: assignMeta(mainOEM)+' - Transaction History V2' }

            },

        ]
    },
    {
        path: '/Login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/HELP/UM',
        name: 'User Manual',
        component: UserManual,
        meta: { title: assignMeta(mainOEM)+' - User Manual' }

    },
    {
        path: '/HELP/VG',
        name: 'Video Guide',
        component: VideoGuide,
        meta: { title: assignMeta(mainOEM)+' - Video Guide' }

    }],
    mode: 'history',
});
}

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (!to || to.fullPath != '/' || (to.fullPath == '/' && from.fullPath == '/')) {
        next();
    } else {
        next(false);
    }
});

export default router;

function assignMeta(mainoem) {
    if (mainoem=="AFBGG"){
        return "GoodGame";
    }else{
        return "AFBKG";
    }


}



// WEBPACK FOOTER //
// ./src/router/index.js